import { useEffect, useState } from 'react';
import { newsletterApi } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Loader2, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

const AdminSubscribers = () => {
  const [data, setData] = useState({ subscribers: [], total: 0, active_count: 0 });
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);

  const fetchSubscribers = async () => {
    try {
      setLoading(true);
      const res = await newsletterApi.getSubscribers({ active_only: true, limit: 200 });
      setData(res);
    } catch (error) {
      console.error('Failed to fetch subscribers:', error);
      toast.error('Abone listesi yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Bu aboneyi silmek istediğinize emin misiniz?')) return;
    setDeletingId(id);
    try {
      await newsletterApi.deleteSubscriber(id);
      toast.success('Abone silindi');
      fetchSubscribers();
    } catch (error) {
      console.error('Failed to delete subscriber:', error);
      toast.error('Abone silinemedi');
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-serif text-2xl font-bold text-foreground">Aboneler</h1>
          <p className="text-sm text-muted-foreground">
            Bülten abonelerinizi görüntüleyin ve yönetin.
          </p>
        </div>
      </div>

      <Card className="bg-card border-border">
        <CardHeader className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 pb-3">
          <CardTitle className="font-serif text-lg">Aktif Aboneler</CardTitle>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span>Toplam: <strong className="text-foreground">{data.total}</strong></span>
            <span>Aktif: <strong className="text-foreground">{data.active_count}</strong></span>
          </div>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
            </div>
          ) : data.subscribers.length === 0 ? (
            <p className="text-sm text-muted-foreground py-8 text-center">
              Henüz abone bulunmuyor.
            </p>
          ) : (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Email</TableHead>
                    <TableHead>Kayıt Tarihi</TableHead>
                    <TableHead className="w-[80px] text-right">İşlem</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {data.subscribers.map((sub) => (
                    <TableRow key={sub._id}>
                      <TableCell className="font-mono text-sm">{sub.email}</TableCell>
                      <TableCell className="text-sm text-muted-foreground">
                        {sub.subscribed_at
                          ? new Date(sub.subscribed_at).toLocaleString('tr-TR')
                          : '-'}
                      </TableCell>
                      <TableCell className="text-right">
                        <Button
                          variant="ghost"
                          size="icon"
                          className="text-destructive"
                          onClick={() => handleDelete(sub._id)}
                          disabled={deletingId === sub._id}
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminSubscribers;
